/*作为项目入口文件main.js的补充文件，主要配置全局的环境参数*/
import '@/plugins/element.js'
import '@/assets/css/base.scss' //全局样式的基础文件
import VariateConfig from '@/assets/config/VariateConfig/index'
import BaseConfig from '@/assets/config/URLConfig'
import vFilters from '@/assets/utils/vFilters'
import directive from '@/assets/utils/directive'
import _axios from '@/assets/utils/_axios'
import * as GlobalFunctions from '@/assets/utils/GlobalFunction'
import connectSocket from '@/assets/utils/connectSocket'
import myComponent from '@/components/GlobalComp'
import {_confirm, _alert} from '@/assets/utils/utils'
import verify from '@/assets/utils/verify'
import CarouselDisplay from '@/components/MultimediaManage/CarouselDisplay'
import VueLazyload from 'vue-lazyload';
import array from '@/assets/utils/array.js'
import object from '@/assets/utils/object.js'
import time from '@/assets/utils/time.js'
const VERSION = '3.5.0';            //当前版本号
let isDev = process.env.NODE_ENV === 'development'
export default (Vue) => {
  /*全局注册过滤器*/
  for (let key in vFilters) {
    Vue.filter(key, vFilters[key])
  }
  /*全局注册自定义指令*/
  for (let key in directive) {
    Vue.directive(key, directive[key])
  }
  /*注册全局axios，函数库，全局变量*/
  let prototypeExtend = [
    {key: 'VERSION', value: VERSION},//版本号
    {key: 'brandId', value: 1},
    {key: '$axios', value: _axios},//axios
    {key: '$GFUN', value: GlobalFunctions},//全局函数库
    {key: '$GVAR', value: VariateConfig},//全局变量
    {key: '$_Array', value: array},//数组对象封装方法
    {key: '$_Object', value: object},//对象对象封装方法
    {key: '$_Time', value: time},   //时间对象封装方法
    {key: '$connectSocket', value: connectSocket},//全局websocket函数,
    {key: '$connSocket', value: connectSocket},//全局websocket函数,
    {key: 'ImgPreUrl', value: BaseConfig.QINIU_URL},//七牛云图片前缀
    {key: 'BASE_URL', value: isDev ? BaseConfig.DEV_API : BaseConfig.API_URL}, //api基础网址
    {key: 'WS_URL', value: isDev ? BaseConfig.DEV_WS_URL : BaseConfig.WS_URL}, //websocket链接网址
    {key: '_confirm', value: _confirm}, //包装后的element-ui全局方法
    {key: '_alert', value: _alert}, //包装后的element-ui全局方法
    {key: '$verify', value: verify}, //包装后的element-ui全局表单验证
    {key: '_CarouselView', value: CarouselDisplay}, //弹框显示多媒体（图片、视频）
    {key: '_IsDevMode', value: BaseConfig.IsDevMode}, //判断是否是测试
  ]
  prototypeExtend.forEach(item => Vue.prototype[item.key] = item.value)

  /*注册全局组件，不需要import，在组件内直接使用*/
  Vue.use(myComponent)
  /*注入图片懒加载插件*/
  Vue.use(VueLazyload, {
    error: '/images/public/defaultImgSmall.png',
    loading: '/images/public/loading.svg'
  });
  /*全局混入*/
  Vue.mixin({
    mounted() {
      // console.log($)
    }
  })
  //判断打开设备自动跳转
  if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    window.location.href = BaseConfig.H5_URL
  }
}
